/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

import '@ciscospark/plugin-authorization-browser-first-party';
import '@ciscospark/internal-plugin-avatar';
import '@ciscospark/internal-plugin-board';
import '@ciscospark/internal-plugin-calendar';
import '@ciscospark/internal-plugin-conversation';
import '@ciscospark/internal-plugin-encryption';
import '@ciscospark/internal-plugin-feature';
import '@ciscospark/internal-plugin-flag';
import '@ciscospark/plugin-logger';
import '@ciscospark/internal-plugin-mercury';
import '@ciscospark/internal-plugin-metrics';
import '@ciscospark/internal-plugin-search';
import '@ciscospark/internal-plugin-support';
import '@ciscospark/internal-plugin-team';
import '@ciscospark/internal-plugin-user';
import '@ciscospark/internal-plugin-lyra';
import '@ciscospark/internal-plugin-wdm';
import '@ciscospark/plugin-people';

import config from './config';
import SparkCore from '@ciscospark/spark-core';
import {merge} from 'lodash';

/**
 * @param {Object} attrs
 * @param {Object} attrs.config
 * @returns {Spark}
 */
export default function CiscoSpark(attrs) {
  attrs = attrs || {};
  attrs.config = merge(config, attrs.config);
  return new SparkCore(attrs);
}
